interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Solana = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_26541)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#160B24"
      />
      <path
        d="M29.7418 26.583L20.2896 36.0313C19.6706 36.6502 20.1099 37.7045 20.9844 37.7045H68.8565C69.3837 37.7045 69.8868 37.4968 70.2622 37.1214L79.7104 27.6732C80.3294 27.0542 79.8901 26 79.0156 26H31.1435C30.6163 26 30.1132 26.2077 29.7378 26.583H29.7418Z"
        fill="url(#paint0_linear_188_26541)"
      />
      <path
        d="M29.7418 61.8961L20.2896 71.3444C19.6706 71.9634 20.1099 73.0176 20.9844 73.0176H68.8565C69.3837 73.0176 69.8868 72.8099 70.2622 72.4346L79.7104 62.9863C80.3294 62.3674 79.8901 61.3131 79.0156 61.3131H31.1435C30.6163 61.3131 30.1132 61.5208 29.7378 61.8961H29.7418Z"
        fill="url(#paint1_linear_188_26541)"
      />
      <path
        d="M29.7418 54.6682L20.2896 45.216C19.6706 44.597 20.1099 43.5428 20.9844 43.5428H68.8565C69.3837 43.5428 69.8868 43.7504 70.2622 44.1258L79.7104 53.574C80.3294 54.193 79.8901 55.2472 79.0156 55.2472H31.1435C30.6163 55.2472 30.1132 55.0396 29.7378 54.6642L29.7418 54.6682Z"
        fill="url(#paint2_linear_188_26541)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_188_26541"
        x1="24.5"
        y1="70"
        x2="76.5"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9945FF" />
        <stop
          offset="1"
          stopColor="#1AF99C"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_188_26541"
        x1="24.5"
        y1="70"
        x2="76.5"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9945FF" />
        <stop
          offset="1"
          stopColor="#1AF99C"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_188_26541"
        x1="24.5"
        y1="70"
        x2="76.5"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9945FF" />
        <stop
          offset="1"
          stopColor="#1AF99C"
        />
      </linearGradient>
      <clipPath id="clip0_188_26541">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
